export default {
    path: '/protect',
    name: 'protect',
    meta: {
        title: '护工端'
    },
    component: resolve => require(['@/views/boss.vue'], resolve),
    redirect: '/protect/home', 
    children: [
        {
            path: '/protect/home',
            name: 'home',
            meta: [{
                path: '/protect/home',
                title: '首页',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/protect/home.vue'], resolve),
        },
        {
            path: '/protect/realTimeMonitoring',
            name: 'realTimeMonitoring',
            meta: [{
                path: '/protect/home',
                title: '首页',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/protect/realTimeMonitoring.vue'], resolve),
        }, 
        {
            path: '/protect/realTimeMonitoringtwo',
            name: 'realTimeMonitoringtwo',
            meta: [{
                path: '/protect/home',
                title: '首页',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/protect/realTimeMonitoringtwo.vue'], resolve),
        },
        {
          path: '/protect/toilet',
          name: 'toilet',
          meta: [{
              path: '/protect/realTimeMonitor',
              title: '实时监测',
              color: "#f2f2f2"
          }],
          component: resolve => require(['@/views/protect/toilet.vue'], resolve),
      },
        {
            path: '/protect/moreBed',
            name: 'moreBed',
            meta: [{
                path: '/protect/moreBed',
                title: '更多床位信息',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/protect/moreBed.vue'], resolve),
        },
    ],
}